import { FeedType } from './models';
import { FEED_QUERY_PARAM_NAME } from './constants';

export const createFeedTypeQueryParam = (feedType: FeedType): string => {
  return `${FEED_QUERY_PARAM_NAME}=${feedType}`;
};

export const getHrefByFeedType = (siteBaseUrl: string, feedType: FeedType) =>
  `${siteBaseUrl}?feedType=${feedType}`;
